import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from '@mui/material';
import { useSelector } from 'react-redux';

function OpuFreezingTable() {
  const borderRight = { borderRight: '1px solid rgba(224, 224, 224, 1)' };
  const { data } = useSelector((state) => state.dataAnalyticsReducer);

  const getCellData = (key, index) => {
    if (
      !data ||
      !data[index] ||
      !data[index].cryopreservation ||
      !data[index].cryopreservation.initialData.data
    ) {
      return 'N/A';
    }

    const freezingInfo = data[index].cryopreservation.initialData.data;

    if (
      key === 'cycleWithFreezing' ||
      key === 'day3' ||
      key === 'day5' ||
      key === 'day6'
    ) {
      let day3Count = 0;
      let day5Count = 0;
      let day6Count = 0;

      for (let i = 0; i < freezingInfo.length; i++) {
        if (!freezingInfo[i].day) {
          continue;
        }
        const days = freezingInfo[i].day.split(', ');
        for (let j = 0; j < days.length; j++) {
          if (days[j] === '3') {
            day3Count++;
          }

          if (days[j] === '5') {
            day5Count++;
          }

          if (days[j] === '6') {
            day6Count++;
          }
        }
      }

      if (key === 'day3') {
        return day3Count;
      }
      if (key === 'day5') {
        return day5Count;
      }
      if (key === 'day6') {
        return day6Count;
      }

      if (key === 'cycleWithFreezing') {
        if (day3Count > 0 || day5Count > 0 || day6Count > 0) {
          return 1;
        }
        return 0;
      }
    }

    if (
      freezingInfo[key] === null ||
      freezingInfo[key] === '' ||
      freezingInfo[key] === ' '
    ) {
      return 'N/A';
    }
    return freezingInfo[key] ?? 'N/A';
  };
  return (
    <Table>
      <TableHead>
        <TableRow>
          <TableCell
            colSpan={4}
            style={{
              fontWeight: 700,
              textAlign: 'center',
              ...borderRight,
            }}
          >
            FREEZING DETAILS
          </TableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        <TableRow>
          <TableCell style={{ fontWeight: 700 }}>
            <div style={{ width: '70px' }}>Cycle With Freezing (0/1)</div>
          </TableCell>
          <TableCell style={{ fontWeight: 700 }}>
            <div style={{ width: '90px' }}>No. of Vitrified Day-3 Embryos</div>
          </TableCell>
          <TableCell style={{ fontWeight: 700 }}>
            <div style={{ width: '90px' }}> No. of Vitrified Day-5 Embryos</div>
          </TableCell>
          <TableCell style={{ fontWeight: 700, ...borderRight }}>
            <div style={{ width: '90px' }}>No. of Vitrified Day-6 Embryos</div>
          </TableCell>
        </TableRow>
        <TableRow>
          <TableCell colSpan={4}>
            <div style={{ height: '20px' }}></div>
          </TableCell>
        </TableRow>
        {data &&
          data.map((_, index) => (
            <TableRow key={index}>
              <TableCell>
                <div
                  style={{
                    height: '60px',
                    display: 'flex',
                    alignItems: 'center',
                  }}
                >
                  {getCellData('cycleWithFreezing', index)}
                </div>
              </TableCell>
              <TableCell>
                <div
                  style={{
                    height: '60px',
                    display: 'flex',
                    alignItems: 'center',
                  }}
                >
                  {getCellData('day3', index)}
                </div>
              </TableCell>
              <TableCell>
                <div
                  style={{
                    height: '60px',
                    display: 'flex',
                    alignItems: 'center',
                  }}
                >
                  {getCellData('day5', index)}
                </div>
              </TableCell>
              <TableCell style={borderRight}>
                <div
                  style={{
                    height: '60px',
                    display: 'flex',
                    alignItems: 'center',
                  }}
                >
                  {getCellData('day6', index)}
                </div>
              </TableCell>
            </TableRow>
          ))}
      </TableBody>
    </Table>
  );
}

export default OpuFreezingTable;
